import type { ZIndices } from '../index';

export const zIndices: ZIndices = {
  toaster: 200,
  bottomSheet: 100,
  modal: 50,
  overlay: 10,
  snackbar: 8,
};
